import { View, Button, Image } from "@/components/ui";
import { Typography } from "../typography";
import { WhatsappIcon } from "@/components/shared/icons";
import CsWhatsapp from "@/assets/images/3d-illus/cs-whatsapp.png";

export const WhatsappSupportBannerBall = ({
  onClick,
}: {
  onClick?: () => void;
}) => {
  return (
    <View
      className="absolute -top-16 right-5 z-10 flex size-12 animate-bounce cursor-pointer items-center justify-center rounded-full bg-white"
      onClick={onClick}
    >
      <WhatsappIcon className="size-8 text-success" />
    </View>
  );
};

interface WhatsappSupportBannerProps {
  onClick: () => void;
}

export const WhatsappSupportBanner = ({
  onClick,
}: WhatsappSupportBannerProps) => {
  return (
    <View className="relative flex flex-row rounded-xl border border-border bg-white">
      <View className="flex w-full flex-1 flex-col p-3">
        <Typography variant="label-sm" className="mb-1">
          Need Help?
        </Typography>
        <Typography
          variant="body-sm"
          color="foreground-intermediate"
          className="mb-2"
        >
          We're here for you
        </Typography>
        <View className="flex flex-row items-center gap-2">
          <Button
            onClick={onClick}
            variant="primary"
            size="md"
            color="success"
            className="relative z-10 gap-2 md:flex-1"
            iconName="whatsappLogo"
            iconColor="fill-white"
            children="Chat Sales"
          />
        </View>
      </View>
      <View className="static bottom-0 right-0 flex flex-col justify-end pr-4 transition-all duration-300 md:absolute md:bottom-12">
        <View className="native:h-24 native:w-24 md:h-[60px] md:w-[60px]">
          <Image src={CsWhatsapp} className="h-full w-full" />
        </View>
      </View>
    </View>
  );
};
